import React, { Component } from 'react'
import { Link } from 'react-router-dom'


export default class MenuMList extends Component {

    closeFx = () => {
        this.props.closeMe()
    }

    render() {

        return (

            <div id='MMenuContainer'>

	            <div id='MMenuHead'>
	                <span>MENU + APPS</span>
	                <i className='material-icons' onClick={this.closeFx}>close</i>
	            </div>

	            <div id='MMenuBody'>
	                <Link to='/'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>home</i><span>Home</span></div></Link>
	                <Link to='/memo'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>list_alt</i><span>Memo</span></div></Link>
					<Link to='/docs'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>archive</i><span>Docs</span></div></Link>
					<Link to='/secret'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>lock</i><span>Keys</span></div></Link>
					<Link to='/mustom'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>shopping_cart</i><span>Mustom</span></div></Link>
	                <Link to='/flashcard'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>translate</i><span>Fcard</span></div></Link>
	                <Link to='/peace'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>hot_tub</i><span>Peace</span></div></Link>
	                <Link to='/movie'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>movie</i><span>Movie</span></div></Link>
	                <Link to='/calendar'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>today</i><span>Days</span></div></Link>
	                <Link to='/share'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>cloud_upload</i><span>Share</span></div></Link>
	                <Link to='/sticky'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>widgets</i><span>Note</span></div></Link>
	                <Link to='/plan'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>explore</i><span>Plan</span></div></Link>
					<Link to='/about'><div className='MMenuMenu' onClick={this.closeFx}><i className='material-icons'>face</i><span>About</span></div></Link>
				</div>

	            <div id='MMenuFoot'>
	                <Link to='/misterp'><span onClick={this.closeFx}>SIGN IN</span></Link>   
	            </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/menu/MenuMList.js